module.exports = __webpack_public_path__ + "static/img/200159.8eee14c4.png";